import { render } from "./CustomCard.vue?vue&type=template&id=e56c00ac"
import script from "./CustomCard.vue?vue&type=script&lang=ts"
export * from "./CustomCard.vue?vue&type=script&lang=ts"
script.render = render

export default script